import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { SampleTestModel } from "../../models/sample-test.model";

interface _SampleTestGetParams {
    search?: string;
}

@injectable()
export class SampleTestRepo extends TableRepo<SampleTestModel> {
    constructor() {
        super("/api/SampleTest");
    }

    async getData(index: number, params: _SampleTestGetParams, pageSize = 10): Promise<ApiPage<SampleTestModel>|null> {
        return await super.getData(index, params, pageSize);
    }
}